import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ControlliService } from '../../../../services/controlli.service';
import { CodiceLookup } from '../../../../models/controlli.model';

/**
 * Popup "Superamenti Reportnet3 ammessi": carica da se' le 3 lookup (tipologie punto di
 * conformita', cause di superamento, azioni correttive) da mostrare all'utente durante
 * la compilazione del file Excel dei superamenti.
 */
@Component({
  selector: 'ebw-monorepo-controlli-codici-superamenti-dialog',
  templateUrl: './controlli-codici-superamenti-dialog.component.html',
  styleUrls: ['./controlli-codici-superamenti-dialog.component.scss']
})
export class ControlliCodiciSuperamentiDialogComponent implements OnInit {
  tipologiePuntoConformita: CodiceLookup[] = [];
  causeSuperamento: CodiceLookup[] = [];
  azioniCorrettive: CodiceLookup[] = [];
  loading = true;

  readonly columns = ['codice', 'descrizione'];

  constructor(
    private _controlliService: ControlliService,
    private _dialogRef: MatDialogRef<ControlliCodiciSuperamentiDialogComponent>
  ) {}

  ngOnInit(): void {
    this._controlliService.getCodiciSuperamenti().subscribe({
      next: (response) => {
        this.tipologiePuntoConformita = response.tipologiePuntoConformita;
        this.causeSuperamento = response.causeSuperamento;
        this.azioniCorrettive = response.azioniCorrettive;
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  close(): void {
    this._dialogRef.close();
  }
}
